import { useTranslate } from 'react-admin';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CollapseMenu from '@/components/common/collapse-menu/collapse-menu';

interface Props {
    externalIdentification: {
        email: string;
        name: string;
    };
}

const ShowNoteExternalIdentification = ({ externalIdentification: { email, name } }: Props) => {
    const translate = useTranslate();

    return (
        <CollapseMenu defaultOpen={true} icon={<AccountCircleIcon />} text={translate('app.objects.documents')}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 1,
                    p: 1,
                    px: 2,
                }}
            >
                {name && (
                    <Typography>
                        <b>{translate('rikutec.externalIdentification.name')}:</b> {name}
                    </Typography>
                )}

                {email && (
                    <Typography>
                        <b>{translate('rikutec.externalIdentification.email')}:</b> {email}
                    </Typography>
                )}
            </Box>
        </CollapseMenu>
    );
};

export default ShowNoteExternalIdentification;
